export default {
  siteName: "AllChinaBuy Spreadsheet",
  siteTagline: "Bessere Produkte finden, Optionen vergleichen & smarter einkaufen",
  navHome: "Startseite",
  navCategories: "Kategorien",
  navGuides: "Guides",
  navShipping: "Versand",
  navReviews: "Bewertungen",
  navSafety: "Sicherheit",
  navComparisons: "Vergleiche",
  navBlog: "Blog",
  navFaq: "FAQ",
  navAbout: "Über",
  navContact: "Kontakt",
  navProducts: "Produkte",
  ctaMain: "Spreadsheet erkunden",
  ctaBuyNow: "Jetzt kaufen",
  ctaGuide: "Guide lesen",
  ctaVisitMain: "Hauptwebsite besuchen",
  trustIndependent: "Unabhängige Ressource",
  trustUpdated: "Aktualisierte Guides",
  trustLanguages: "4 Sprachen",
  heroTitle: "AllChinaBuy Spreadsheet — Bessere Produkte finden, Optionen vergleichen & smarter einkaufen",
  heroSubtitle: "Erkunden Sie AllChinaBuy Spreadsheet Ressourcen, Produktfunde, Verkäuferguides, QC-Tipps, Versandinformationen, Bewertungen und praktische Kaufratschläge — alles an einem Ort.",
  heroCtaPrimary: "AllChinaBuy Spreadsheet erkunden",
  heroCtaSecondary: "Anfängerguide starten",
  sectionWhatIs: "Was ist das AllChinaBuy Spreadsheet?",
  sectionWhatIsDesc: "Das AllChinaBuy Spreadsheet ist eine kuratierte Ressource, die Käufern hilft, Qualitätsprodukte zu entdecken, Verkäufer zu vergleichen und fundierte Kaufentscheidungen zu treffen. Es bündelt Produktfunde, Bewertungen und Kauftipps in einem organisierten Hub.",
  sectionCategories: "Beliebte Spreadsheet-Kategorien",
  sectionHowItWorks: "So funktioniert das Spreadsheet",
  sectionHowItWorksStep1: "Kategorien durchsuchen oder Produkte suchen",
  sectionHowItWorksStep2: "Verkäufer, Preise und QC-Details vergleichen",
  sectionHowItWorksStep3: "Kaufguides und Sicherheitstipps folgen",
  sectionHowItWorksStep4: "Sicher über vertrauenswürdige Links kaufen",
  sectionReview: "AllChinaBuy Bewertung",
  sectionReviewDesc: "Eine unabhängige, ehrliche Bewertung der AllChinaBuy Plattform mit Versand, QC, Gebühren, Lager Services und Gesamtnutzererfahrung. Regelmäßig mit echten Einblicken aktualisiert.",
  sectionShipping: "Versandkosten Guide",
  sectionShippingDesc: "Verstehen Sie, wie Versandkosten basierend auf Gewicht, Ziel, Paketgröße, Versandlinie und saisonalen Faktoren berechnet werden. Lernen Sie, wie Sie mit Konsolidierung und Versicherungsoptionen Versandkosten sparen.",
  sectionWarehouse: "Lager & QC",
  sectionWarehouseDesc: "Lernen Sie, wie der AllChinaBuy Lagerprozess funktioniert: von Verkäuferlieferung bis QC-Inspektion, Genehmigung, Konsolidierung und endgültigem Paketversand. Wichtiges Wissen für jeden Käufer.",
  sectionSafety: "Sicherheitszentrum",
  sectionSafetyDesc: "URLs verifizieren, Verkäuferbewertungen prüfen, QC-Fotos inspizieren und sichere Zahlungspraktiken befolgen. Unsere Sicherheitsguides helfen Ihnen, Betrug zu vermeiden und mit Vertrauen einzukaufen.",
  sectionComparison: "AllChinaBuy vs Wettbewerber",
  sectionComparisonDesc: "Vergleichen Sie AllChinaBuy mit Superbuy, CSSBuy und Sugargoo. Sehen Sie die Unterschiede bei Gebühren, Versand, QC, Lager Services und Benutzererfahrung, um den besten Agent für Ihre Bedürfnisse zu finden.",
  sectionArticles: "Neueste Guides & Artikel",
  sectionFaq: "Häufig gestellte Fragen",
  finalCtaTitle: "Bereit, das AllChinaBuy Spreadsheet zu erkunden?",
  finalCtaDesc: "Starten Sie mit den neuesten Spreadsheet-Ressourcen, Guides und Kaufinformationen.",
  footerAbout: "Über",
  footerPolicy: "Redaktionelle Richtlinie",
  footerDisclaimer: "Haftungsausschluss",
  footerPrivacy: "Datenschutz",
  footerTerms: "Bedingungen",
  footerContact: "Kontakt",
  readMore: "Mehr lesen",
  learnMore: "Mehr erfahren",
  lastUpdated: "Zuletzt aktualisiert",
  relatedArticles: "Verwandte Artikel",
  tableFeature: "Funktion",
  tableAllChinaBuy: "AllChinaBuy",
  tableSuperbuy: "Superbuy",
  tableCSSBuy: "CSSBuy",
  tableSugargoo: "Sugargoo",
  categoryShoes: "Schuhe",
  categorySneakers: "Sneakers",
  categoryHoodies: "Kapuzenpullover/Pullover",
  categoryTShirts: "T-Shirts",
  categoryJackets: "Jacken",
  categoryPants: "Hosen/Shorts",
  categoryHeadwear: "Kopfbedeckungen",
  categorySets: "Sets",
  categoryUnderwear: "Unterwäsche",
  categoryJersey: "Trikots",
  categoryAccessories: "Accessoires",
  categoryBags: "Taschen",
  categoryBelts: "Gürtel",
  categoryPerfumes: "Parfums",
  categoryOther: "Sonstiges",
  articleTitle1: "AllChinaBuy Spreadsheet Guide 2026: So finden Sie die besten Produkte",
  articleDesc1: "Ein vollständiger Guide zur Navigation im AllChinaBuy Spreadsheet, zum Verstehen von Kategorien und zum Finden von Qualitätsprodukten mit verifizierten Verkäufern und QC-Tipps.",
  articleTitle2: "Ist AllChinaBuy legitim? Vollständiger Sicherheits- & Vertrauensguide",
  articleDesc2: "Eine unabhängige Bewertung der Legitimität von AllChinaBuy, Sicherheitspraktiken, Zahlungsschutz und wie man häufige Kauffehler vermeidet.",
  articleTitle3: "AllChinaBuy vs Superbuy: Welchen Agenten sollten Sie wählen?",
  articleDesc3: "Ein detaillierter Vergleich von AllChinaBuy und Superbuy mit Gebühren, Versand, QC, Lager Services und Gesamtnutzererfahrung.",
  faq1Q: "Was ist das AllChinaBuy Spreadsheet?",
  faq1A: "Das AllChinaBuy Spreadsheet ist eine kuratierte Sammlung von Produktfunden, Verkäuferinformationen und Kauftipps nach Kategorien organisiert. Es hilft Käufern, Qualitätsartikel zu entdecken und Optionen vor dem Kauf zu vergleichen.",
  faq2Q: "Ist AllChinaBuy sicher zu verwenden?",
  faq2A: "AllChinaBuy ist eine legitime Einkaufsagenten-Plattform. Wie jeder internationale Einkaufsservice sollten Käufer Sicherheitspraktiken befolgen: Verkäuferbewertungen verifizieren, QC-Fotos prüfen, sichere Zahlungsmethoden nutzen und Bewertungen vor dem Kauf lesen.",
  faq3Q: "Wie funktioniert der Versand bei AllChinaBuy?",
  faq3A: "AllChinaBuy bietet mehrere Versandlinien basierend auf Ziel, Gewicht und Paketgröße. Die Kosten hängen vom tatsächlichen oder volumetrischen Gewicht, dem Zielland und der gewählten Versandmethode ab. Konsolidierung und Versicherungsoptionen sind verfügbar.",
  faq4Q: "Kann ich den Produktempfehlungen des Spreadsheets vertrauen?",
  faq4A: "Das Spreadsheet ist eine unabhängige Ressource, die Community-Funde und Bewertungen zusammenstellt. Während wir Informationen nach bestem Wissen verifizieren, sollten Sie immer eigene QC-Kontrollen durchführen und Verkäuferbewertungen lesen, bevor Sie kaufen.",
  faq5Q: "Was ist QC und warum ist es wichtig?",
  faq5A: "QC (Qualitätskontrolle) ist der Inspektionsprozess, bei dem Lagermitarbeiter Ihre Artikel auf Mängel, Größenprobleme oder falsche Produkte vor dem Versand überprüfen. Es ist entscheidend, um Probleme früh zu erkennen und Umtausch oder Rückerstattung zu beantragen.",
  pageNotFound: "Seite nicht gefunden",
  pageNotFoundDesc: "Die gesuchte Seite existiert nicht. Kehren Sie zur Startseite zurück, um AllChinaBuy Spreadsheet Ressourcen zu erkunden.",
  backToHome: "Zurück zur Startseite",
  allchinabuySpreadsheet: "AllChinaBuy Spreadsheet",
  spreadsheetHub: "Spreadsheet Hub",
  comparison: "Vergleich",
  warehouse: "Lager",
  review: "Bewertung",
  coupon: "Gutschein",
  discountCode: "Rabattcode",
  legit: "Legitim",
  shippingCost: "Versandkosten",
  beginnersGuide: "Anfängerguide",
  qcGuide: "QC Guide",
  sellerGuide: "Verkäufer Guide",
  buyingChecklist: "Kauf Checkliste",
  productVerification: "Produktverifikation",
  safetyCenter: "Sicherheitszentrum",
  paymentSafety: "Zahlungssicherheit",
  sellerSafety: "Verkäufer Sicherheit",
  qcSafety: "QC Sicherheit",
  shippingSafety: "Versandsicherheit",
  scamWarning: "Betrugswarnung",
  alternatives: "Alternativen",
  vsSuperbuy: "AllChinaBuy vs Superbuy",
  vsCSSBuy: "AllChinaBuy vs CSSBuy",
  vsSugargoo: "AllChinaBuy vs Sugargoo",
  languageEnglish: "Englisch",
  languageFrench: "Französisch",
  languageDanish: "Dänisch",
  languageGerman: "Deutsch",
  breadcrumbHome: "Startseite",
  editorialTitle: "Redaktionelle Richtlinie",
  editorialDesc: "Diese Website bietet unabhängige Bildungsinformationen und ist nicht mit AllChinaBuy verbunden. Wir garantieren keine Produktqualität, Verkäuferzuverlässigkeit oder Versandergebnisse. Verifizieren Sie Informationen immer unabhängig.",
  cookieNotice: "Wir verwenden Cookies, um Ihre Erfahrung zu verbessern. Durch die Fortsetzung stimmen Sie unserer Nutzung von Cookies zu.",
  cookieAccept: "Akzeptieren",
  productsTitle: "Produktkatalog",
  productsSubtitle: "Durchsuchen Sie unsere kuratierte Sammlung verifizierter Produkte aus dem AllChinaBuy Spreadsheet. Klicken Sie auf ein Element, um Details anzusehen und zu kaufen.",
  productsSearchPlaceholder: "Produkte suchen...",
  allCategories: "Alle",
  noProductsFound: "Keine Produkte gefunden.",
  buyNow: "Jetzt kaufen",
};